import React from 'react'
import useOperation from '../hooks/use-operation'
import { useConstrainable } from '@morningtrain/react-filters'

export default function SetOperationConstraintsFromEnv () {
  const operation = useOperation()
  const constrainable = useConstrainable()

  React.useEffect(() => {
    if (!operation) {
      return
    }

    const actionFilters = operation.filters
    const filterKeys = operation.filterKeys

    if (filterKeys.length > 0) {
      filterKeys.forEach(key => {
        const filterData = actionFilters[key]
        if (filterData && filterData.required === true) {
          constrainable.setConstraint(filterData.key, filterData.value, false)
        }
      })
    }
  })

  return null
}
